import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgress from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import CustomSelectNew from "components/UpdateUi/CustomeSelect";
import FindStructureData from "helper/FindStructureType";
import ToastModal from "views/components/ToastModal";
import { useOutletContext } from "react-router-dom";
import { parseAndSetFlag } from "utils/Utils";

const PacketDamageCreate = ({
  classes,
  packetAllocationShow,
  packetId,
  setPacketId,
  closeModal,
  rawData,
}) => {
  const [serialNumber, setSerialNumber] = useState("");
  const [serialNumberStateError, setSerialNumberStateError] = useState(false);
  const [packetSize, setPacketSize] = useState("");
  const [packetSizeState, setPacketSizeState] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [branchName, setBranchName] = useState("");
  const [branchNameState, setBranchNameState] = useState(false);
  const [reasonErrorState, setReasonErrorState] = useState(false);
  const [reason, setReason] = useState("");
  const [structureTypeData, setStructureTypeData]= useState([]);
  const [remarks, setRemarks] = useState("");
  const [packetWeightState, setPacketWeightState]= useState(false);
  const [packetWeight, setPacketWeight]= useState("")
  const [branchList, setBranchList] = useState([]);
  const [packetList, setPacketList] = useState([]);
  const [isValid,setIsValid]=useState(false);
  const packetSizes = [
    { code: "3.0*3.0", name: "3.0*3.0" },
    { code: "3.0*6.0", name: "3.0*6.0" },
    { code: "6.0*3.0", name: "6.0*3.0" },
    { code: "6.0*6.0", name: "6.0*6.0" },
    { code: "10.0*6.5", name: "10.0*6.5" },
  ];
  const outletData = useOutletContext();
  const removedPacketSize = outletData?.removePacketSizeFlag;
  const getAllPacketNumbers = parseAndSetFlag(outletData?.getAllPacketNumbers);
  const packetSizeList = JSON.parse(outletData?.packetSizesList) || packetSizes;
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
  };
  const isValidated = () => {
    if (branchName === "") {
      setBranchNameState(true);
    } else {
      setBranchNameState(false);
    }
    if (packetSize === "") {
      setPacketSizeState(true);
    } else {
      setPacketSizeState(false);
    }
    if (serialNumber === "") {
      setSerialNumberStateError(true);
    } else {
      setSerialNumberStateError(false);
    }
    if(packetWeight === ""){
      setPacketWeightState(true);
    }else{
      setPacketWeightState(false)
    }
    if (reason === "") {
      setReasonErrorState(true);
    } else {
      setReasonErrorState(false);
    }
    if (remarks === "") {
      toastUpdate("Error", "Fill Remarks", true);
      return false;
    }
    if (serialNumber === "" || branchName === "" || packetSize === "" || reason === "" || remarks === ""|| packetWeight === "") {
      return false;
    } else {
      return true;
    }
  };
  useEffect(() => {
    if(structureTypeData.length){
      getBranchList();
    }
  }, [structureTypeData.length]);
  useEffect(()=>{
    FindStructureData(apiHandler,endpoint,authToken, setStructureTypeData)
},[])
  useEffect(()=>{
    if(packetSize && branchName){
    GetAvailablePackets();}
  },[packetSize,branchName])
  useEffect(() => {
    if (packetId) {
      GetData();
    }
    getBranchList();
  }, []);

  const getBranchList = async () => {
    let branchList = [];
    let branchCodes = structureTypeData.filter((b) => b.branchType === true);
    if (branchCodes.length > 0) {
      branchCodes.forEach(async (branch) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.MASTER_HIERARCHY_FIND_BY_TYPE_CODE + branch?.code,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setBranchList(result?.data);
    }
})
    }
  };
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.PACKET_DAMAGE_FIND_BY_ID + packetId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setPacketSize(result?.data?.size);
      setBranchName(result?.data?.branchCode?.toUpperCase());
      setReason(result?.data?.reason);
      setPacketWeight(result?.data?.packetWeight)
      setRemarks(result?.data?.remarks);
      setSerialNumber(result?.data?.serialNo);
    }
  };
  const GetAvailablePackets = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.PACKETS_SERIAL_NUMBER + branchName?.toUpperCase() + "?size=" + packetSize + "&allPackets=" + getAllPacketNumbers,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      const serialNumberMap = result?.data?.serialNumberMap;
      let packetNumbers = Array.isArray(result?.data?.serialNumbers)
        ? result.data.serialNumbers
        : serialNumberMap && typeof serialNumberMap === "object"
          ? Object.keys(serialNumberMap)
          : [];
      setPacketList(packetNumbers)
    }
  };
  const handleCreateSubmit = async (event) => {
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.PACKET_DAMAGE_CREATE,
        method: "POST",
        authToken: authToken,
        data: {
          branchCode: branchName?.toUpperCase(),
          packetNumber: serialNumber,
          size: packetSize,
          packetWeight:packetWeight,
          reason: reason,
          remarks: remarks,
          date: new Date(),
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code && res?.data?.error_code === 403) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        closeModal("create");
        packetAllocationShow(true);
      }
    }
  };

  const handleEditSubmit = async () => {
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.PACKET_DAMAGE_UPDATE + packetId,
        method: "PUT",
        authToken: authToken,
        data: {
          branchCode: "BO1",
          packetNumber: serialNumber,
          size: packetSize,
          reason: reason,
          remarks: remarks,
          date: new Date(),
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code && res?.data?.error_code === 403) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        closeModal("update");
        packetAllocationShow(true);
      }
    }
  };
  const handleCancel = () => {
    packetAllocationShow(true);
    setPacketId("");
  };

  const handleSerialNumber = (e) =>{
    const isSerialNumberExists = rawData.some((item) => item.serialNo === Number(e));
    if (isSerialNumberExists) {
      toastUpdate("Error", "Serial number already present", true);
      setIsValid(true)
      return false;
    }
    setIsValid(false);
    return true;
  }
  const handlePacketNumber = (e) => {
      setSerialNumber(e);
  };
  const handleChange = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setPacketWeight(e);
    }
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={packetId ? "Edit Packet Damage" : "Packet Damage"}
          button1=" Save"
          button2=" Cancel"
          button1click={packetId ? handleEditSubmit : handleCreateSubmit}
          button2click={handleCancel}
          disabled1={isValid}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Branch Name*"
              error={branchNameState}
              id="branch_channel"
              value={branchName?.toUpperCase()}
              setState={setBranchName}
              data={branchList}
              setError={setBranchNameState}
              type= "TYPE"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Packet Size"
              error={packetSizeState}
              value={packetSize}
              setState={setPacketSize}
              data={packetSizeList}
              setError={setPacketSizeState}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          {packetId ?
           <CustomTextField
           label="Serial Number"
           error={serialNumberStateError}
           id="lp_branch_code"
           disabled={true}
           value={serialNumber || ""}
           setState={handlePacketNumber}
           setError={setSerialNumberStateError}
         />  :
          <CustomSelectNew
              label="Serial Number"
              required
              error={serialNumberStateError}
              id="lp_branch_code"
              value={serialNumber || ""}
              setState={handlePacketNumber}
              setError={setSerialNumberStateError}
              data={packetList}
              type= "packetNumbers"
            />
          }
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Packet Weight"
              required
              error={packetWeightState}
              id="lp_branch_code"
              value={packetWeight || ""}
              setError={setPacketWeightState}
              setState={handleChange}
              // setBlur={(e)=>handleInputChange(e,"to")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Reason"
              required
              error={reasonErrorState}
              id="reason"
              value={reason || ""}
              setError={setReasonErrorState}
              setState={setReason}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <textarea
              placeholder="Remarks"
              onChange={(e) => setRemarks(e.target.value)}
              value={remarks}
              required
              style={{ width: "100%", borderRadius: "5px" }}
            />
          </Grid>
        </Grid>
      </Grid>
      {callInProgress && <CircularProgress callInProgress={callInProgress} />}
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
    </Grid>
  );
};

PacketDamageCreate.propTypes = {
  classes: PropTypes.object,
};

export default PacketDamageCreate;
